import React from 'react';

// Diamond SVG component - the brand mark
// Blue: forward motion, active, result moments
// Near-black: structural, cover, wordmark
// White: inside blue buttons

export const Diamond = ({ color = 'blue', size = 'md', className = '' }) => {
  const colors = {
    blue: '#0057FF',
    black: '#0F0F0F',
    white: '#FFFFFF',
  };

  const sizes = {
    sm: { width: 5, height: 8 },
    md: { width: 7, height: 11 },
    lg: { width: 11, height: 18 },
    hero: { width: 22, height: 35 },
  };

  const { width, height } = sizes[size] || sizes.md;
  const fill = colors[color] || colors.blue;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block align-middle ${className}`}
      data-testid={`diamond-${color}-${size}`}
    >
      <polygon
        points="5.5,0 11,9 5.5,18 0,9"
        fill={fill}
      />
    </svg>
  );
};

export default Diamond;
